// Change listener
CartItems.on("change", function() {
	if (CartItems.count()) {
		$(".js-cart-items-count").addClass('visible').text(CartItems.count()).closest(".header__cart").addClass('cart-filled');
		$(".js-show-cart-not-empty").show();
		$(".js-show-cart-empty").hide();
		$(".js-cart-items-count").toggleClass('oval', CartItems.count() > 9);
		if($(window).width() <= 1050) {
			$(".js-cart-items-count").closest('.header').addClass('floating-visible'), CartItems.count() > 1;

			if($('.header').hasClass('floating-visible')) {
				$('.header').siblings('.floating').addClass('cart-filled');
			} 
		} 

	} else {
		$(".js-cart-items-count").removeClass('visible').closest(".header__cart").removeClass('cart-filled');
		$(".js-show-cart-not-empty").hide();	
		$(".js-show-cart-empty").show();
		if($('.header').hasClass('floating-visible')) {	
			$('.header').siblings('.floating').removeClass('cart-filled');
		}
	}
	
	if (CartItems.empty() || !CartItems.acceptTOS) {
		$(".js-btn-order").attr("disabled", true).prop("disabled", true);
	} else {
		$(".js-btn-order").removeAttr("disabled", true).removeProp("disabled", true);
	}
});

$("[name=has_invoice]").on("change", function(){
	$(".form-invoice").toggleClass("show", $(this).is(':checked'));
}).trigger("change");

$(".js-toggle-tos").on("change", function() {
	if ($(this).is(":checked")) {
		CartItems.setAcceptTos(true);
		$("#order-button").removeAttr("disabled").removeProp("disabled");
	} else {
		CartItems.setAcceptTos(false);
		$("#order-button").attr("disabled", true).prop("disabled", true);
	}
}).trigger("change");

$(".js-payment-method").on("change", function() {

	if ($(this).is(":checked")) {
		CartItems.paymentMethod = $(this).val();

		$('#cart-bank-transfer').toggleClass('visible', $(this).val() == 'bank_transfer');
		$('#cart-cash-on-delivery').toggleClass('visible', $(this).val() == 'cash_on_delivery');
		$('#cart-card-payment').toggleClass('visible', $(this).val() == 'card_payment');
	}

}).trigger("change");

$(".js-delivery-method").on("change", function() {
	let selectedOption   = $(this).find('option:selected');

	if (selectedOption.length > 0) {
		let addressField         = $('.form__group--address');
		let addressClarification = addressField.data('address-clarification');
		let officeClarification  = addressField.data('office-clarification');
	
		let price             = selectedOption.data('delivery-price');
		let freeDeliveryPrice = selectedOption.data('free-shipping-threshold');
		let deliveryCategory  = selectedOption.data('delivery-category');
	
		if (price) {
			CartItems.setDelivery({'price': price, 'freeShippingThreshold': freeDeliveryPrice});
		}
	
		addressField.find('.address-clarification').text(deliveryCategory == 'curbside' ? officeClarification : addressClarification);
	}
}).trigger("change");